export const heatmapViewPadding = 45;
